import React, { useState } from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const QuoteAiDashboard = () => {
  const [show, setShow] = useState(false);
  const [selectedState, setSelectedState] = useState('');
  const [selectedBusiness, setSelectedBusiness] = useState(null);
  const [acordForm, setAcordForm] = useState('');

  const navigate = useNavigate();
  const states = ['Select State', 'California', 'Texas', 'New York'];
  const businessLines = [
    {
      id: 1,
      img: '/assets/quoteAi/images/comensation.svg',
      label: 'Worker Compensation',
      color: 'bg-blue',
    },
    {
      id: 2,
      img: '/assets/quoteAi/images/liability.svg',
      label: 'General Liability',
      color: 'bg-lightblue',
    },
    { id: 3, img: '/assets/quoteAi/images/auto.svg', label: 'Auto', color: 'bg-yellow' },
    { id: 4, img: '/assets/quoteAi/images/property.svg', label: 'Property', color: 'bg-purple' },
    { id: 5, img: '/assets/quoteAi/images/package.svg', label: 'Package', color: 'bg-green' },
    { id: 6, img: '/assets/quoteAi/images/other.svg', label: 'Other', color: 'bg-lightgreen' },
  ];

  const [startDate, setStartDate] = useState(new Date('2024-11-01'));
  const [endDate, setEndDate] = useState(new Date('2024-11-30'));

  const percentage = 66;
  const placeholder = 'Select a date'; // Define placeholder text

  const handleStartQuote = () => {
    if (acordForm === 'no') {
      navigate('/quoteAI/insuredInformationPage'); // Navigate when "No" is selected
    } else {
      // Handle the "Yes" case or show an error if needed
    }
  };

  return (
    <div id="quoteAi">
      <div
        className="main"
        // style={{ marginTop: '2rem' }}
      >
        <div className="gos-page-actions" style={{ justifyContent: 'flex-end', padding: '12px 16px 0' }}>
          <div className="dropdown">
            <button
              type="button"
              className="gos-btn gos-btn-ghost"
              id="pncDashboardSwitch"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="gos-dash-dot"></span>
              P&amp;C Dashboard
              <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
                <path d="M6 9l6 6 6-6" />
              </svg>
            </button>
            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="pncDashboardSwitch">
              <li>
                <Link className="dropdown-item" to="/dashboard">Standard Dashboard</Link>
              </li>
            </ul>
          </div>
        </div>
        {/*
        <header className="top-header">

          <div className="flex-div">
            <div className="toggle-Menu"><i className="bi bi-list"></i></div>
            <div className="logo"><img src="assets/images/logo.png" alt="United Federation Insurance Underwriters" />
            </div>

          </div>
          <div className="flex-div hdrRight">
            <div className="search"><i className="bi bi-search"></i></div>
            <div className="notification"><i className="bi bi-bell"></i>
              <span className="notiNumber">12</span>
            </div>
            <div className="profile flex-div">
              <div className="pText">
                <span className="pName">John Doe</span>
                <span className="pDes">Agent</span>
              </div>
              <div className="pImg">
                <img src="assets/images/user.png" alt="John Doe" />
              </div>
            </div>
          </div>

        </header> */}

        <div className="pageOuterBlock" style={{ marginTop: '35px' }}>
          <div className=" container-fluid  mb-3">
            <div className="pageLeftBlock">
              <div className="whiteBoxCont mrgTop">
                <div className="topButton">
                  <div className="topLeft flex-div">
                    <button className="btn tabsBtn">Monthly</button>
                    <button className="btn btn-outline-secondary lightBtn">Quarterly</button>
                    <button className="btn btn-outline-secondary lightBtn">Yearly</button>
                    <div className="date-picker-panel">
                      <div className="date-picker-container">
                        <div className="date-picker-wrapper">
                          {/* <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            dateFormat="dd-MM-yyyy"
                            className="custom-date-input"
                          /> */}
                          <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            dateFormat="dd-MM-yyyy"
                            className="custom-date-input"
                            placeholderText="Select Date"
                            calendarClassName="custom-calendar"
                          />
                          {/* SVG Calendar Icon */}
                          <span className="calendar-icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                              <line x1="16" y1="2" x2="16" y2="6"></line>
                              <line x1="8" y1="2" x2="8" y2="6"></line>
                              <line x1="3" y1="10" x2="21" y2="10"></line>
                              <path d="M8 14h.01"></path>
                              <path d="M12 14h.01"></path>
                              <path d="M16 14h.01"></path>
                              <path d="M8 18h.01"></path>
                              <path d="M12 18h.01"></path>
                              <path d="M16 18h.01"></path>
                            </svg>
                          </span>
                        </div>

                        <span className="date-separator">to</span>

                        <div className="date-picker-wrapper">
                          <DatePicker
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            dateFormat="dd-MM-yyyy"
                            className="custom-date-input"
                            placeholderText="Select Date"
                            calendarClassName="custom-calendar"
                          />
                          {/* SVG Calendar Icon */}
                          <span className="calendar-icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                              <line x1="16" y1="2" x2="16" y2="6"></line>
                              <line x1="8" y1="2" x2="8" y2="6"></line>
                              <line x1="3" y1="10" x2="21" y2="10"></line>
                              <path d="M8 14h.01"></path>
                              <path d="M12 14h.01"></path>
                              <path d="M16 14h.01"></path>
                              <path d="M8 18h.01"></path>
                              <path d="M12 18h.01"></path>
                              <path d="M16 18h.01"></path>
                            </svg>
                          </span>
                        </div>
                      </div>
                    </div>
                    <button className="btn btn-primary">Submit</button>
                  </div>
                  <div className="topRight">
                    <button className="btn btn-outline-primary">
                      <i className="bi bi-box-arrow-up"></i>
                      Export
                    </button>
                    <button className="btn btn-outline-primary" onClick={() => setShow(true)}>
                      <i className="bi bi-file-earmark-text"></i>
                      <span>Quote</span>
                    </button>
                  </div>
                </div>
              </div>
              <div className="whiteBoxCont mrgTop">
                <div className="kpiContainer">
                  <div className="kpiHdr">
                    <h2>Key Performance Indicators</h2>
                    <div className="labelText">Novemebr, 2024</div>
                  </div>

                  <div className="kpiText">
                    <div className="row g-3 mb-4">
                      <div className="col-md-2 col-sm-6">
                        <div className="card kpi-card">
                          <div className="card-body">
                            <h6 className="card-subtitle mb-2">Quotes/Indications</h6>
                            <span className="percentage ">
                              <i className="bi bi-arrow-up text-success"></i> 12.5%
                            </span>
                            <div className="d-flex align-items-center">
                              <CircularProgressbar value={percentage} text={`${percentage}%`} />
                              <div className="ms-3">
                                <h4 className="card-title mb-0">755</h4>
                                <small className="text-muted">of 1,000</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-2 col-sm-6">
                        <div className="card kpi-card">
                          <div className="card-body">
                            <h6 className="card-subtitle mb-2">Bound/Indications</h6>
                            <span className="percentage ">
                              <i className="bi bi-arrow-up text-success"></i> 12.5%
                            </span>
                            <div className="d-flex align-items-center bluePrg">
                              <CircularProgressbar value={percentage} text={`${percentage}%`} />
                              <div className="ms-3">
                                <h4 className="card-title mb-0">755</h4>
                                <small className="text-muted">of 1,000</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-2 col-sm-6">
                        <div className="card kpi-card">
                          <div className="card-body">
                            <h6 className="card-subtitle mb-2">Bound/Quote</h6>
                            <span className="percentage ">
                              <i className="bi bi-arrow-up text-success"></i> 12.5%
                            </span>
                            <div className="d-flex align-items-center">
                              <CircularProgressbar value={percentage} text={`${percentage}%`} />
                              <div className="ms-3">
                                <h4 className="card-title mb-0">755</h4>
                                <small className="text-muted">of 1,000</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-2 col-sm-6">
                        <div className="card kpi-card">
                          <div className="card-body">
                            <h6 className="card-subtitle mb-2">Issued/Bound</h6>
                            <span className="percentage ">
                              <i className="bi bi-arrow-up text-success"></i> 12.5%
                            </span>
                            <div className="d-flex align-items-center bluePrg">
                              <CircularProgressbar value={percentage} text={`${percentage}%`} />
                              <div className="ms-3">
                                <h4 className="card-title mb-0">755</h4>
                                <small className="text-muted">of 1,000</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-2 col-sm-6">
                        <div className="card kpi-card">
                          <div className="card-body">
                            <h6 className="card-subtitle mb-2">Straight-thru/Quotes</h6>
                            <span className="percentage ">
                              <i className="bi bi-arrow-up text-success"></i> 12.5%
                            </span>
                            <div className="d-flex align-items-center ">
                              <CircularProgressbar value={percentage} text={`${percentage}%`} />
                              <div className="ms-3">
                                <h4 className="card-title mb-0">755</h4>
                                <small className="text-muted">of 1,000</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-2 col-sm-6">
                        <div className="card kpi-card">
                          <div className="card-body">
                            <h6 className="card-subtitle mb-2">Renewed/Reneable</h6>
                            <span className="percentage ">
                              <i className="bi bi-arrow-up text-success"></i> 12.5%
                            </span>
                            <div className="d-flex align-items-center bluePrg">
                              <CircularProgressbar value={percentage} text={`${percentage}%`} />
                              <div className="ms-3">
                                <h4 className="card-title mb-0">755</h4>
                                <small className="text-muted">of 1,000</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-2 col-sm-6">
                        <div className="card kpi-card">
                          <div className="card-body">
                            <h6 className="card-subtitle mb-2">Issued/Indications</h6>
                            <span className="percentage ">
                              <i className="bi bi-arrow-up text-success"></i> 12.5%
                            </span>
                            <div className="d-flex align-items-center">
                              <CircularProgressbar value={percentage} text={`${percentage}%`} />
                              <div className="ms-3">
                                <h4 className="card-title mb-0">755</h4>
                                <small className="text-muted">of 1,000</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-2 col-sm-6">
                        <div className="card kpi-card">
                          <div className="card-body">
                            <h6 className="card-subtitle mb-2">Issued/Quotes</h6>
                            <span className="percentage ">
                              <i className="bi bi-arrow-up text-success"></i> 12.5%
                            </span>
                            <div className="d-flex align-items-center bluePrg">
                              <CircularProgressbar value={percentage} text={`${percentage}%`} />
                              <div className="ms-3">
                                <h4 className="card-title mb-0">755</h4>
                                <small className="text-muted">of 1,000</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-sm-12 col-md-5">
                  <div className="whiteBoxCont mrgTop">
                    <div className="kpiHdr">
                      <h2>Transactions Status Details</h2>
                    </div>
                    <div className="transactionDetail">
                      <div className="transactiontext greenBdr">
                        <h3>
                          Indications <span>150</span>
                        </h3>
                        <div className="labelRow">
                          <div className="labelSpan ">
                            <span className="green">120</span> Completed
                          </div>
                          <div className="labelSpan ">
                            <span className="red">30</span> Incomplete
                          </div>
                        </div>
                      </div>
                      <div className="progressText">
                        <span>
                          <i className="bi bi-arrow-down"></i> 80%
                        </span>
                      </div>
                    </div>

                    <div className="transactionDetail">
                      <div className="transactiontext blueBdr">
                        <h3>
                          Quotes <span>120</span>
                        </h3>
                        <div className="labelRow">
                          <div className="labelSpan ">
                            <span className="green">80</span> Completed
                          </div>
                          <div className="labelSpan ">
                            <span className="yellow">25</span> Pending
                          </div>
                          <div className="labelSpan ">
                            <span className="red">30</span> Incomplete
                          </div>
                        </div>
                      </div>
                      <div className="progressText">
                        <span>
                          <i className="bi bi-arrow-down"></i> 62.5%
                        </span>
                      </div>
                    </div>

                    <div className="transactionDetail">
                      <div className="transactiontext greenBdr">
                        <h3>
                          Bound <span>75</span>
                        </h3>
                        <div className="labelRow">
                          <div className="labelSpan ">
                            <span className="green">60</span> Completed
                          </div>
                          <div className="labelSpan ">
                            <span className="yellow">10</span> Pending
                          </div>
                          <div className="labelSpan ">
                            <span className="red">5</span> Incomplete
                          </div>
                        </div>
                      </div>
                      <div className="progressText">
                        <span>
                          <i className="bi bi-arrow-down"></i> 80%
                        </span>
                      </div>
                    </div>

                    <div className="transactionDetail">
                      <div className="transactiontext blueBdr">
                        <h3>
                          Issued <span>63</span>
                        </h3>
                        <div className="labelRow">
                          <div className="labelSpan ">
                            <span className="green">55</span> Completed
                          </div>
                          <div className="labelSpan ">
                            <span className="yellow">5</span> Pending
                          </div>
                          <div className="labelSpan ">
                            <span className="red">3</span> Incomplete
                          </div>
                        </div>
                      </div>
                      <div className="progressText">
                        <span>
                          <i className="bi bi-arrow-down"></i> 80%
                        </span>
                      </div>
                    </div>

                    <div className="transactionDetail">
                      <div className="transactiontext greenBdr">
                        <h3>
                          Renewals <span>27</span>
                        </h3>
                        <div className="labelRow">
                          <div className="labelSpan ">
                            <span className="green">20</span> Completed
                          </div>
                          <div className="labelSpan ">
                            <span className="yellow">5</span> Pending
                          </div>
                          <div className="labelSpan ">
                            <span className="red">2</span> Incomplete
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="statusSymbol">
                      <ul>
                        <li className="roundClip greenClip">Completed</li>
                        <li className="roundClip yellowClip">Pending</li>
                        <li className="roundClip redClip">Incompleted</li>
                        <li className="roundClip blueClip">Reinstatements</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-sm-12 col-md-7">
                  <div className="whiteBoxCont conht mrgTop">
                    <div className="kpiHdr">
                      <div className="flex-div">
                        <h2>Workbook</h2>
                        <div className="searchBlock">
                          <input
                            type="text"
                            placeholder="Search here..."
                            className="form-control"
                            value="Search here..."
                          />
                          <i className="bi bi-search"></i>
                        </div>
                      </div>
                      <div className="actionBtn">
                        <button className="btn btn-outline-primary">
                          <i className="bi bi-journals"></i>
                          Full Workbook
                        </button>

                        <button className="btn btn-outline-primary" onClick={() => setShow(true)}>
                          <i className="bi bi-plus-lg"></i>
                          Quotes
                        </button>
                        <select className="form-select pageNo">
                          <option value="option1">5</option>
                          <option value="option1">10</option>
                          <option value="option1">20</option>
                        </select>
                      </div>
                    </div>
                    <div className="tableBlock">
                      <table className="table">
                        <thead>
                          <tr>
                            <th scope="col"></th>
                            <th scope="col">Ref</th>
                            <th scope="col">Insured Name</th>
                            <th scope="col">Agent Name</th>
                            <th scope="col">Agency Name</th>
                            <th scope="col">LOB</th>
                            <th scope="col">Effective Date</th>
                            <th>Alfred Alerts</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <th scope="row">
                              <i className="bi bi-plus-lg"></i>
                            </th>
                            <td>Q000001245</td>
                            <td>AL Church Methodist</td>
                            <td>John Doe</td>
                            <td>Doe Insurance</td>
                            <td>WC</td>
                            <td>03/23/2024</td>
                            <td></td>
                            <td>
                              <i className="bi bi-three-dots-vertical"></i>
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">
                              <i className="bi bi-plus-lg"></i>
                            </th>
                            <td>Q000001245</td>
                            <td>AL Church Methodist</td>
                            <td>John Doe</td>
                            <td>Doe Insurance</td>
                            <td>WC</td>
                            <td>03/23/2024</td>
                            <td></td>
                            <td>
                              <i className="bi bi-three-dots-vertical"></i>
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">
                              <i className="bi bi-plus-lg"></i>
                            </th>
                            <td>Q000001245</td>
                            <td>AL Church Methodist</td>
                            <td>John Doe</td>
                            <td>Doe Insurance</td>
                            <td>WC</td>
                            <td>03/23/2024</td>
                            <td></td>
                            <td>
                              <i className="bi bi-three-dots-vertical"></i>
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">
                              <i className="bi bi-plus-lg"></i>
                            </th>
                            <td>Q000001245</td>
                            <td>AL Church Methodist</td>
                            <td>John Doe</td>
                            <td>Doe Insurance</td>
                            <td>WC</td>
                            <td>03/23/2024</td>
                            <td></td>
                            <td>
                              <i className="bi bi-three-dots-vertical"></i>
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">
                              <i className="bi bi-plus-lg"></i>
                            </th>
                            <td>Q000001245</td>
                            <td>AL Church Methodist</td>
                            <td>John Doe</td>
                            <td>Doe Insurance</td>
                            <td>WC</td>
                            <td>03/23/2024</td>
                            <td></td>
                            <td>
                              <i className="bi bi-three-dots-vertical"></i>
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">
                              <i className="bi bi-plus-lg"></i>
                            </th>
                            <td>Q000001245</td>
                            <td>AL Church Methodist</td>
                            <td>John Doe</td>
                            <td>Doe Insurance</td>
                            <td>WC</td>
                            <td>03/23/2024</td>
                            <td></td>
                            <td>
                              <i className="bi bi-three-dots-vertical"></i>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <nav>
                      <ul className="pagination justify-content-end mt-3">
                        <li className="page-item disabled">
                          <a className="page-link">Previous</a>
                        </li>
                        <li className="page-item active">
                          <a className="page-link" href="#">
                            1
                          </a>
                        </li>
                        <li className="page-item">
                          <a className="page-link" href="#">
                            2
                          </a>
                        </li>
                        <li className="page-item">
                          <a className="page-link" href="#">
                            3
                          </a>
                        </li>
                        <li className="page-item">
                          <a className="page-link" href="#">
                            Next
                          </a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="rightMenuPanel">
            <div className="iconBlock">
              <ul>
                <li className="iconBg" data-tooltip-id="my-tooltip" data-tooltip-content="Workbook">
                  <img src="../assets/quoteAi/images/reading.svg" alt="" />
                </li>
                <li className="iconBg" data-tooltip-id="my-tooltip" data-tooltip-content="alfraid">
                  <img src="../assets/quoteAi/images/alert.svg" alt="" />
                </li>
              </ul>
              <ReactTooltip id="my-tooltip" style={{ backgroundColor: '#2563eb' }}></ReactTooltip>
            </div>
          </div>
        </div>
      </div>

      {/* *******************************************Modal********************************************* */}

      <Modal
        show={show}
        onHide={() => setShow(false)}
        className="quoteai_popup"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton className="title-header">
          <div>
            <Modal.Title as="h3">Create New Quote</Modal.Title>
            <p className="subtitle d-block">
              Select the line of business and primary state to start a new quote.
            </p>
          </div>
        </Modal.Header>
        <Modal.Body>
          {/* Step 1: Line Of Business */}
          <h4 className="step-title"> Line Of Business</h4>
          <Row>
            {businessLines.map((item) => (
              <Col
                key={item.id}
                md={2}
                sm={12}
                xs={12}
                className="mb-3 d-flex justify-content-center"
              >
                <div
                  className={`business-card ${item.color} ${selectedBusiness === item.id ? 'selected' : ''}`}
                  onClick={() => setSelectedBusiness(item.id)}
                  style={{ backgroundColor: item.bgColor }}
                >
                  <div className="business-icon-container">
                    <img src={item.img} alt={item.label} className="popup-icon" />
                  </div>
                  <span className="business-label">{item.label}</span>
                </div>
              </Col>
            ))}
          </Row>

          {/* Step 2: Primary State */}
          <h4 className="step-title d-flex align-items-center">
            Primary State
            <span
              className="ms-2"
              data-tooltip-id="my-tooltip"
              data-tooltip-content=" Select the primary state for the quote."
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="info-icon"
                viewBox="0 0 16 16"
              >
                <path d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16Z" />
                <path d="m8.93 6.588-.862.126-.088.45c.176-.098.364-.177.563-.236.198-.059.38-.088.545-.088.235 0 .428.057.578.17.15.114.225.267.225.46 0 .172-.05.311-.15.418-.099.106-.237.196-.412.27-.175.073-.404.166-.688.277-.284.112-.516.244-.695.396-.18.153-.305.333-.376.542-.072.208-.108.467-.108.777h1.002c0-.206.021-.376.063-.512.042-.136.106-.249.192-.34.085-.09.193-.162.324-.215.13-.053.287-.105.47-.157.234-.071.425-.156.572-.253.146-.098.26-.22.342-.366.081-.146.122-.321.122-.523 0-.329-.107-.576-.322-.74-.214-.164-.503-.246-.865-.246-.207 0-.397.025-.572.074Zm-1.862 4.312c0-.238.068-.417.204-.54.136-.122.312-.184.528-.184.216 0 .392.062.528.184.136.123.204.302.204.54 0 .237-.068.416-.204.538-.136.122-.312.183-.528.183-.216 0-.392-.061-.528-.183-.136-.122-.204-.301-.204-.538Z" />
              </svg>
            </span>
            <ReactTooltip id="my-tooltip" style={{ backgroundColor: '#2563eb' }}></ReactTooltip>
          </h4>

          <Form.Group className="state-select-group">
            <Form.Label>State</Form.Label>
            <Form.Select value={selectedState} onChange={(e) => setSelectedState(e.target.value)}>
              {states.map((state, index) => (
                <option key={index} value={state}>
                  {state}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          {/* Step 3: ACORD Form */}
          <h4 className="step-title"> Do you have an ACORD form?</h4>
          <Form.Group>
            <div className="d-flex align-items-center">
              <Form.Check
                type="radio"
                label="Yes"
                name="acordForm"
                id="acordYes"
                className="me-3"
                checked={acordForm === 'yes'}
                onChange={() => setAcordForm('yes')}
              />
              <Form.Check
                type="radio"
                label="No"
                name="acordForm"
                id="acordNo"
                checked={acordForm === 'no'}
                onChange={() => setAcordForm('no')} // Just update state, don't navigate immediately
              />
            </div>
          </Form.Group>

          {/* File Upload Section (Show only if "Yes" is checked) */}
          {acordForm === 'yes' && (
            <div className="file-upload-section mt-3">
              <Form.Group controlId="formFile">
                <Form.Label className="step-title">Upload ACORD Form</Form.Label>
                <Form.Control type="file" />
              </Form.Group>
            </div>
          )}
        </Modal.Body>

        {/* Footer */}
        <Modal.Footer className="quote_buttongroup">
          <Button variant="outline-cancel" onClick={() => setShow(false)}>
            Cancel
          </Button>
          <Button variant="primary-save" onClick={handleStartQuote}>
            Start Quote
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default QuoteAiDashboard;
